import { NavLink } from "react-router-dom";
import { FileText, Sprout } from "lucide-react";

const TABS = [["/app/foundations", Sprout, "My Roots Profile", "roots-tab-profile"], ["/app/brand-foundations", FileText, "Your Brand Foundations", "roots-tab-brand"]];

export const RootsTabs = () => (
  <div className="mb-6 flex flex-wrap gap-2" role="tablist" data-testid="roots-tabs">
    {TABS.map(([to, Icon, label, id]) => (
      <NavLink key={to} to={to} role="tab" data-testid={id}
        className={({ isActive }) => `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm transition-colors ${isActive ? "bg-navy text-white" : "bg-secondary text-navy hover:bg-secondary/70"}`}>
        <Icon className="h-4 w-4" />{label}
      </NavLink>
    ))}
  </div>
);
